module.exports = __webpack_public_path__ + "static/img/logos.695e9f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos.png
// module id = rmE0
// module chunks = 1